<template>
  <div>
    <div v-if="!loading">
      <template v-if="!selectDoctorFlag">
        <div class="sa-mob-cont sa-mob-cont-padbt">
          <button class="sa-btn-back" @click="$parent.referDoctor = false">
            <i class="icon-arrow-left"></i>
          </button>
          <h5 class="sa-card-tit sa-ref-tit">Department / Doctor</h5>
          <div class="sa-row">
            <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg6">
              <div class="sa-form-group">
                <label>Select Service</label>
                <v-select
                  :options="serviceType"
                  :reduce="(type) => type.key"
                  v-model="stid"
                  class="diagno-select"
                  name="Service Type"
                  ><span slot="no-options">No data</span></v-select
                >
              </div>
            </div>
            <!-- <div v-if="hospitalList" class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg3">
          <div class="sa-form-group">
            <label>Select Provider</label>
            <v-select @input="getDoctors" :options="hospitalList" :reduce ="title => title.eid" label="en_nm" v-model="eid" class="diagno-select"></v-select>
          </div>
        </div> -->
          </div>
          <div class="sa-row">
            <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg6">
              <div class="sa-form-group">
                <label>Select Department</label>
                <v-select
                  :options="depList"
                  :reduce="(dep) => dep.dept_id"
                  id="depList"
                  name="Dep List"
                  label="dept_name"
                  v-model="dept_id"
                  class="diagno-select"
                  ><span slot="no-options">No data</span></v-select
                >
                <span v-if="depErr" class="sa-red-text"
                  >Please select department</span
                >
              </div>
            </div>
          </div>
          <div class="sa-test-pack-check">
            <div class="sa-form-group">
              <input
                type="checkbox"
                id="checkbox"
                v-model="checked"
                name="checkbox"
              />
              <label for="checkbox">Refer to doctor</label>
            </div>
          </div>
          <div v-if="checked" class="sa-row">
            <div
              class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg6 sa-dropimage"
            >
              <div class="sa-form-group">
                <label>Select Doctor</label>
                <div
                  @click="selectDoctor"
                  class="sa-form-control sa-select-doctor"
                >
                  <figure v-if="doctorInfo" class="sa-avtar sa-avtar-xs">
                    <img
                      :src="doctorInfo.img ? doctorInfo.img : unknownImg"
                      alt="Doctor"
                      class="sa-img-cover"
                    />
                  </figure>
                  <h6 v-if="doctorInfo">
                    {{ doctorInfo.title_nm }} {{ doctorInfo.name }}
                    <small v-if="doctorInfo && doctorInfo.class_nm"
                      >{{ doctorInfo.class_nm }},{{
                        doctorInfo.splst_name
                      }}</small
                    >
                    <small v-else>{{ doctorInfo.splst_name }}</small>
                  </h6>
                  <i class="icon-right-arrow"></i>
                </div>
                <!-- <v-select
                :options="options"
                label="title"
                v-model="uid"
                class="diagno-select "
                @click="$emit('close-pop')"
              >
                <template slot="option" slot-scope="option">
                  <div class="sa-d-f-a-center">
                  <figure class="sa-avt-img"><img :src="option.cardImage" alt="Doctor" class="sa-img-cover"></figure>
                  <div class="sa-doct-det"><span>{{ option.title }} </span></div>
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option" :value="option.level" >
                  <figure class="sa-avt-img"><img :src="option.cardImage" alt="Doctor" class="sa-img-cover"></figure>
                  <div class="sa-doct-det"><span>{{ option.title }} </span></div>
                </template>
              </v-select> -->

                <!-- <v-select :options="options" :searchable="false" v-model="uid" :clearable="false" label="title">
          <template slot="option" slot-scope="option">
            <img :src="option.image" />
          </template>

          <template slot="selected-option" slot-scope="option" :value="option.level">
            <img :src="'images/' + option.level + '.png'" />
            {{ option.title }}
          </template>
        </v-select> -->
              </div>
            </div>
          </div>
        </div>
        <div class="sa-ftr-btn">
          <button
            :disabled="loader"
            @click="referDoctor"
            class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs"
          >
            Continue
          </button>
        </div>
      </template>
      <search-doctor :stid="stid" :dept_id="dept_id" v-if="selectDoctorFlag" />
    </div>
    <div v-if="loading">
      <img
        src="../../../../assets/img/loader.svg"
        alt="loader"
        class="sa-loader sa-loader-top"
      />
    </div>
  </div>
</template>
<script>
import { pro_url } from "../../../../../config/endpoints";
import Avtar from "../../../common/Avtar.vue";
import SearchDoctor from "./SearchDoctor.vue";
import async from "async";
export default {
  props: ["viewDoctor", "stid", "dept_id", "ref_doctorId"],
  mounted() {
    let _self = this;
    _self.patDetails = JSON.parse(_self.$localStorage.get("patDetails"));
    _self.loading = true;
    async.parallel(
      [_self.getDepartments.bind(), _self.getDoctorDetails.bind()],
      () => {
        _self.loading = false;
      }
    );
  },
  components: { Avtar, SearchDoctor },
  data() {
    return {
      unknownImg: "https://img.litedev.com/images/unknown-avtar.png",
      depErr: false,
      doctorInfo: null,
      selectDoctorFlag: false,
      selectDocFlag: false,
      serviceType: [
        {
          key: "ST1",
          label: "Video Consultation",
        },
        {
          key: "ST0",
          label: "Home Visit",
        },
      ],
      loader: false,
      options: [
        {
          title: "Raju Doctor",
          cardImage: "https://img.litedev.com/images/unknown-avtar.png",
        },
        {
          title: "Manu Doctor",
          cardImage:
            "https://img.litedev.com/mis/44f6c6650fa36dae2911fde3756117a8.jpg",
        },
      ],
      optionsa: [
        {
          level: 1,
          title: "Image 1",
          image: "images/1.png",
        },
        {
          level: 2,
          title: "Image 2",
          image: "images/2.png",
        },
        {
          level: 3,
          title: "Image 3",
          image: "images/3.png",
        },
      ],
      checked: false,
      patDetails: null,
      uid: null,
      eid: null,
      hospitalList: [],
      doctorList: [
        {
          uid: "",
          name: "",
        },
      ],
      loading: false,
      depList: [],
    };
  },
  watch: {
    stid: {
      immediate: false,
      deep: true,
      handler() {
        this.getDepartments(() => {});
      },
    },
    dept_id: {
      immediate: false,
      deep: true,
      handler() {
        this.$parent.dept_id = this.dept_id;
        this.$parent.stid = this.stid;
        this.$parent.doctorInfo = null;
        this.doctorInfo = null;
      },
    },
    viewDoctor: {
      immediate: false,
      deep: true,
      handler() {
        this.$parent.viewDoctor = this.viewDoctor;
        this.$parent.doctorInfo = this.doctorInfo;
      },
    },
  },
  methods: {
    getDoctorDetails: function (callback) {
      if (!this.ref_doctorId) return callback();
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/refer/doctorDetails`,
          body: {
            uid: _self.ref_doctorId,
          },
        })
        .then((response) => {
          if (response && response.data) {
            _self.doctorInfo = response.data;
            _self.checked = true;
          }
          return callback();
        });
    },
    selectDoctor: function () {
      if (!this.dept_id) {
        this.depErr = true;
        return;
      }
      this.depErr = false;
      if (!this.selectDocFlag) {
        this.selectDoctorFlag = true;
        this.selectDocFlag = true;
      } else {
        this.selectDoctorFlag = false;
        this.selectDocFlag = false;
      }
    },
    getDepartments: function (callback) {
      let _self = this;
      if (!_self.stid) {
        _self.stid = "ST1";
      }
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/refer/departments`,
          body: {
            stid: _self.stid,
          },
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.depList = response.data;
          }
          return callback();
        });
    },
    doctor() {
      this.doctorFlag = !this.doctorFlag;
    },
    referDoctor() {
      this.loading = true;
      let _self = this;
      let ref_doctorId = "";
      if (_self.doctorInfo) {
        ref_doctorId = _self.doctorInfo.uid;
      }
      _self.patDetails = JSON.parse(_self.$localStorage.get("patDetails"));
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/refer/addTreatmentReferal`,
          body: {
            apnt_id: _self.patDetails.apnt_id,
            // pid: _self.patDetails.pid,
            stid: _self.stid,
            ref_doctorId: ref_doctorId,
            dept_id: _self.dept_id,
            pkg_id: _self.patDetails.refPackages || [],
            tsk_id: _self.patDetails.refNurse || [],
            tst_id: _self.patDetails.refTests || [],
            trtmnt_id: _self.patDetails.refPhysio || [],
          },
        })
        .then((response) => {
          _self.loading = false;
          if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Referred doctor successfully",
              class: "sa-a-success",
            });
            _self.patDetails.refDoctor = _self.uid;
            _self.patDetails.stid = _self.stid;
            _self.patDetails.dept_id = _self.dept_id;
            _self.$localStorage.set(
              "patDetails",
              JSON.stringify(_self.patDetails)
            );
            _self.$parent.referDoctor = false;
            _self.$parent.getReferralData();
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg:
                "Something went wrong. Please try again or contact operations team",
              class: "sa-a-danger",
            });
          }
        });
    },
    getDoctors() {
      if (this.eid && this.dept_id) {
        this.loading = true;
        let _self = this;
        _self.$store
          .dispatch("httpPost", {
            uri: `${pro_url}/refer/doctors`,
            body: {
              eid: _self.eid,
              dept_id: _self.dept_id,
            },
          })
          .then((response) => {
            _self.loading = false;
            if (response && response.status === 1000) {
              _self.doctorList = response.data;
            }
          });
      }
    },
  },
};
</script>
